﻿import angular from 'angular';
import _ from "lodash";

import DateExtended from "../../../services-js/date.service.ts";

import '../../../services/product';
import '../../../services/cart';
import '../../../services/datastorage';
import '../../../services/media';

import ribbon from "../../../models/ProductRibbon";

import '../favorites';

angular.module('folkeuni').component('productDetail', {
    bindings: {
        areaId: '<',
        categoryUrl: '@',
        currentProgramUrl: '@',
        siteType: '@',
        siteName: '@',
        siteId: '<',
        isFestival: '<',
        useClerk: '=',
        productId: '@',
        productUrl: '@',
        websiteUrl: '@'
    },
    templateUrl: '/shop-dist/templates/product-detail.html?c=' + window.cacheBurst,
    transclude: false,
    controller: function (Media, DataStorage, Product, Cart, $sce, $filter, $location, $window, $timeout) {
        var $ctrl = this;
        $ctrl.noMatch = false;
        $ctrl.product = {};
        $ctrl.isProductCancelled = false;
        $ctrl.eventCount = 0;
        $ctrl.eventsCancelledCount = 0;
        $ctrl.waitlistCourses = [];
        $ctrl.productImageUrl = "";
        $ctrl.relations = [];
        $ctrl.waitlistObj = {
            course: null,
            email: null,
            name: null
        }
        $ctrl.waitlistStatus = null;
        $ctrl.showDetail = true;
        $ctrl.admissionClosed = false;
        $ctrl.colorTheme = '';
        $ctrl.ribbons = [];

        $ctrl.waitlistSubmit = function () {
            $ctrl.waitlistStatus = "loading";
            $ctrl.waitlistErrorMsg = null;

            var waitlistObj = {
                SiteId: $ctrl.siteId,
                Name: $ctrl.waitlistObj.name,
                Email: $ctrl.waitlistObj.email,
                ProductId: $ctrl.product.id,
                CourseId: $ctrl.waitlistObj.course.id
            }
            if (!waitlistObj.Name) {
                $ctrl.waitlistStatus = "error";
                $ctrl.waitlistErrorMsg = "Du skal udfylde navn";
            } else if (!waitlistObj.Email) {
                $ctrl.waitlistStatus = "error";
                $ctrl.waitlistErrorMsg = "Du skal udfylde e-mail";
            }

            if ($ctrl.waitlistStatus == "loading") {
                Cart.waitlistSubscribe(waitlistObj).then(function (response) {

                    $ctrl.waitlistStatus = "success";
                }, function (errorResponse) {
                    console.log("Error", errorResponse);
                    $ctrl.waitlistStatus = "error";
                    $ctrl.waitlistErrorMsg = "Der er sket en fejl med din tilmelding til ventelisten, kontakt os venligst og lad os hjælpe dig.";
                });
            }
        }

        function addParamaterToString(fullString) {
            var updatedString = fullString;

            if (updatedString.indexOf('?') == -1) {
                updatedString += "?";
            }
            else {
                updatedString += "&"
            }

            return updatedString;
        }

        $ctrl.coursesCount = function () {
            var coursesToShow = _.filter($ctrl.product.courses, function (course) { return !course.hideEvents });
            return coursesToShow.length
        }

        $ctrl.formatEmployeesString = function (employees) {
            return employees.map((employee) => {
                let educator = [employee.name || '', employee.title || ''].filter((item)=>{return item.length}).join(', ');
                return educator;
            }).join(' og ');
        }

        $ctrl.getOptionNormalPrice = function (option) {
            var result = "";

            for (var i = 0; option.prices.length > i; i++) {
                var currentPrice = option.prices[i];

                if (currentPrice.type == "Normal") {
                    result = currentPrice.value;
                    break;
                }
            }

            return result;
        }

        function dynamicSort(property) {
            var sortOrder = 1;
            if (property[0] === "-") {
                sortOrder = -1;
                property = property.substr(1);
            }
            return function (a, b) {
                var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                return result * sortOrder;
            }
        }

        $ctrl.getClerkRelatedProductsList = function(content) {
            switch (parseInt($ctrl.areaId)) {
                case 1:
                    return content + "-aarhus";
                case 2:
                    return content + "-emdrup";
                case 3:
                    return content + "-herning";
                case 4:
                    return content + "-odense";
                case 5:
                    return content + "-kolding";
                case 6:
                    return content + "-esbjerg";
                default:
                    return content;
            }
        }

        $ctrl.$onInit = function () {

            //TODO: Dobbelttjek at dette er smartest metode at få produktet på, med produkt id
            $ctrl.productIdentification = $ctrl.productId ? $ctrl.productId : $ctrl.productUrl;

            Product.getProduct($ctrl.siteId, $ctrl.productIdentification, "?crop=5:3").then(
                function (product) {
                    $ctrl.colorTheme = product.colorThemeId ? "theme-" + product.colorThemeId : "";
                    $ctrl.relations =
                        product.relations && product.relations.length ? product.relations : $ctrl.relations;
                    $ctrl.useClerk =
                        product.clerkAltRelated && product.clerkAltRelated == "disableClerk" ? false : $ctrl.useClerk;

                    if (product.options != null && product.options.length > 0) {
                        for (var i = 0; product.options.length > i; i++) {
                            var currentOptionGroup = product.options[i];

                            for (var y = 0; currentOptionGroup.items.length > y; y++) {
                                currentOptionGroup.items[y].priceFormatted = $ctrl.getOptionNormalPrice(
                                    currentOptionGroup.items[y]
                                );
                            }
                        }
                    }

                    product.options.sort(dynamicSort("id"));
                    product.courses = product.courses || [];

                    var theDate = product.startDate
                        ? product.startDate
                        : product.courses && product.courses.length > 0
                        ? product.courses[0].events[0].startDate
                        : product.events[0].startDate;
                    const eventCount = product.events > 1 ? product.events + " gange" : "";
                    product.durationFormatted = product.durationSummary ? product.durationSummary : eventCount;
                    product.startDateFormatted = window.formatDates(theDate, product.durationFormatted, true);

                    $ctrl.product = product;
                    $ctrl.product.available = 0;
                    $ctrl.product.maxAttendance = 0;
                    $ctrl.product.descriptionHtml = $sce.trustAsHtml($ctrl.product.description);
                    $ctrl.product.locationMultiple = false;
                    $ctrl.product.orderLink = $ctrl.product.buttonDisabled
                        ? "javascript:void(0)"
                        : $ctrl.product.buttonLink
                        ? $ctrl.product.buttonLink
                        : $ctrl.product.primaryUrl + "/bestil";

                    if (typeof Storage !== "undefined") {
                        DataStorage.set("lastVisitedProduct", $ctrl.product.id);
                    }

                    if (!$ctrl.product.buttonLink && $ctrl.product.primaryUrl) {
                        $ctrl.product.orderLink =
                            $ctrl.websiteUrl +
                            $ctrl.product.primaryUrl.substring($ctrl.product.primaryUrl.indexOf(".dk") + 4) +
                            "/bestil";
                    }

                    // Events dates and locations enrichment
                    if ($ctrl.product.locationSummary) {
                        $ctrl.product.locationDescription = $ctrl.product.locationSummary;
                    }

                    for (var i = 0; $ctrl.product.courses.length > i; i++) {
                        var currentCourse = $ctrl.product.courses[i];

                        //Check if sold out - to show waitlist
                        if (currentCourse.available == 0) {
                            currentCourse.startDateFormatted = new DateExtended(currentCourse.events[0].startDate).format(
                                "[dddd] d. [DD].[MM].[YYYY] kl. [HH]:[mm]"
                            );
                            if (!$ctrl.waitlistObj.course) {
                                $ctrl.waitlistObj.course = currentCourse;
                            }
                            $ctrl.waitlistCourses.push(currentCourse);
                        }

                        //Total ticketstatus for product
                        $ctrl.product.maxAttendance = $ctrl.product.maxAttendance + currentCourse.maxAttendance;
                        $ctrl.product.available = $ctrl.product.available + currentCourse.available;

                        Product.ticketStatus($ctrl.siteId, currentCourse).then(
                            function (updatedCourse) {
                                currentCourse = updatedCourse;
                            },
                            function (errorResponse) {}
                        );

                        if (currentCourse.events.length > 0) {
                            $ctrl.product.eventLocations = [];

                            for (var y = 0; currentCourse.events.length > y; y++) {
                                var currentEvent = currentCourse.events[y];

                                //Is entire course cancelled?
                                //count each cancelled event and compare later
                                $ctrl.eventCount++;
                                if (currentEvent.cancelled) {
                                    $ctrl.eventsCancelledCount++;
                                }

                                if (
                                    !$ctrl.product.locationMultiple &&
                                    !$ctrl.product.locationSummary &&
                                    currentEvent.location
                                ) {
                                    const locationAddress = currentEvent.location.address;
                                    var locationPostalCode = currentEvent.location.postalCode;
                                    var locationCity = currentEvent.location.city;
                                    $ctrl.product.locationDescription =
                                        currentEvent.location.name +
                                        (locationAddress != null ? "<br/>" + locationAddress : "") +
                                        (locationPostalCode != null ? "<br/>" + locationPostalCode : "") +
                                        (locationCity != null ? " " + locationCity : "");
                                }

                                //Is location similiar to first location?

                                if (
                                    currentEvent.location &&
                                    currentEvent.location.id != currentCourse.events[0].location.id &&
                                    !$ctrl.product.locationMultiple &&
                                    !$ctrl.product.locationSummary
                                ) {
                                    $ctrl.product.locationMultiple = true;
                                    $ctrl.product.locationDescription = "Flere lokationer.";
                                }

                                if (currentEvent.location) {
                                    if (!$ctrl.product.eventLocations.includes(currentEvent.location.id)) {
                                        $ctrl.product.eventLocations.push(currentEvent.location.id);
                                    }
                                }

                                //Is start date == end date?
                                //and if hidedate or time from KA

                                if ($ctrl.product.hideDate && $ctrl.product.hideTime) {
                                    currentEvent.dateDescription = "";
                                } else {
                                    const isSameDay =
                                        new DateExtended(currentEvent.startDate).format("[DD][MM][YYYY]") ==
                                        new DateExtended(currentEvent.endDate).format("[DD][MM][YYYY]");
                                    const currentFormat = [
                                        createFormat("hideDate", "[dddd]. kl. [HH].[mm]", $ctrl.product.hideDate),
                                        createFormat("hideTime", "[dddd]. [D]/[M]/[YY]", $ctrl.product.hideTime),
                                        createFormat("default", "[dddd]. [D]/[M]/[YY] kl. [HH].[mm]", true)
                                    ].filter((item) => {
                                        return item.use;
                                    })[0];

                                    currentEvent.dateDescription = capitalizeFirstLetter(
                                        new DateExtended(currentEvent.startDate).format(currentFormat.format)
                                    );
                                    if (!(isSameDay && currentFormat.name === "hideTime")) {
                                        currentEvent.dateDescription +=
                                            " - " +
                                            (isSameDay
                                                ? new DateExtended(currentEvent.endDate).format("[HH].[mm]")
                                                : capitalizeFirstLetter(
                                                      new DateExtended(currentEvent.endDate).format(
                                                          currentFormat.format
                                                      )
                                                  ));
                                    }

                                    function createFormat(name, format, use) {
                                        return { name: name, format: format, use: use };
                                    }

                                    function capitalizeFirstLetter(string) {
                                        return string.replace(/(^\w)/g, (item) => {
                                            return item.toUpperCase();
                                        });
                                    }
                                }
                            }
                        }
                    }

                    if ($ctrl.eventCount == $ctrl.eventsCancelledCount && !$ctrl.ended) {
                        $ctrl.product.cancelled = true;
                    }

                    Product.ticketStatus($ctrl.siteId, $ctrl.product).then(
                        function (updatedProduct) {
                            $ctrl.product = updatedProduct;
                            if ($ctrl.siteId == 1 && $ctrl.product.prices.length > 0) {
                                if (window.dataLayer) {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        event: "viewProduct",
                                        productId: $ctrl.product.id,
                                        productTitle: $ctrl.product.name,
                                        productDefaultPrice: Number($ctrl.product.prices[0].value.split(",")[0])
                                    });
                                }
                            }
                            $ctrl.handleRibbons();
                        },
                        function (errorResponse) {
                            $ctrl.noMatch = true;
                        }
                    );

                    $ctrl.admissionClosed =
                        $ctrl.product.courses.filter(function (item) {
                            return item.registrationOpen;
                        }).length === 0;

                    $ctrl.product.locationDescription = $sce.trustAsHtml($ctrl.product.locationDescription);
                        if (window.Clerk != null) {
                            setTimeout(() => {
                                window.Clerk("content", ".clerk-recommendations");
                            }, 10);
                        }
                },
                function (errorObj) {
                    $ctrl.noMatch = true;
                }
            );
        }

        $ctrl.handleRibbons = () => {
            let state = getRibbon();
            if (state != null) {
                $ctrl.ribbons.push(state);
            }

            function getRibbon() {
                if ($ctrl.product.cancelled && !$ctrl.product.ended) {
                    return new ribbon({
                        text: "AFLYST",
                        styleClass: "cancelled"
                    });
                }
                
                if ($ctrl.product.ticketStatus && (($ctrl.areaId == 7 && $ctrl.product.ticketStatus.title != 'AFLYST') || $ctrl.areaId != 7)) {
                    return new ribbon({
                        text: $ctrl.product.ticketStatus.title,
                        styleClass: $ctrl.product.ticketStatus.class
                    });
                }

                if (new Date($ctrl.product.startDateEnd) < new Date()) {
                    return new ribbon({
                        text: "Startet",
                        styleClass: "started"
                    });
                }

                return null;
            }
        };

        $ctrl.saveCategory = function () {
            var categoryUrl = window.location.href.substring(0, window.location.href.indexOf('/program') + 9);
            DataStorage.set('lastUsedDepartmentProgram', categoryUrl);
        }

    }
});
